import { Routes } from '@angular/router';
import { AUTH_REDIRECT_ROUTE } from '@shared/constants/fields.constants';
import { ngxPermissionsGuard } from 'ngx-permissions';

export const tenderPlanningRoutes: Routes = [
  {
    path: 'tender-planning/generation-configuration',
    loadComponent: () =>
      import('./generation-configuration/tender-calendar-generation-configuration.component').then(
        (component) => component.TenderCalendarGenerationConfigurationComponent,
      ),
    canActivate: [ngxPermissionsGuard],
    data: {
      permissions: {
        only: ['ROLE_MANAGE_TENDER_CALENDAR_RULES'],
        redirectTo: AUTH_REDIRECT_ROUTE,
      },
    },
  },
  {
    path: 'tender-planning/calendars',
    loadComponent: () =>
      import('./tender-calendars/tender-calendars.component').then(
        (component) => component.TenderCalendarsComponent,
      ),
    canActivate: [ngxPermissionsGuard],
    data: {
      permissions: {
        only: ['ROLE_VIEW_TENDER_CALENDAR'],
        redirectTo: AUTH_REDIRECT_ROUTE,
      },
    },
  },
  {
    path: 'tender-planning/calendars/new',
    loadComponent: () =>
      import('./tender-calendar-form/tender-calendar-form.component').then(
        (component) => component.TenderCalendarFormComponent,
      ),
    canActivate: [ngxPermissionsGuard],
    data: {
      permissions: {
        only: ['ROLE_CREATE_TENDER_CALENDAR'],
        redirectTo: AUTH_REDIRECT_ROUTE,
      },
    },
  },
  {
    path: 'tender-planning/calendars/:uuid/edit',
    loadComponent: () =>
      import('./tender-calendar-form/tender-calendar-form.component').then(
        (component) => component.TenderCalendarFormComponent,
      ),
    canActivate: [ngxPermissionsGuard],
    data: {
      permissions: {
        only: ['ROLE_UPDATE_TENDER_CALENDAR'],
        redirectTo: AUTH_REDIRECT_ROUTE,
      },
    },
  },
  {
    path: 'tender-planning/calendars/:uuid',
    loadComponent: () =>
      import('./tender-calendar-detail/tender-calendar-detail.component').then(
        (component) => component.TenderCalendarDetailComponent,
      ),
    canActivate: [ngxPermissionsGuard],
    data: {
      permissions: {
        only: ['ROLE_VIEW_TENDER_CALENDAR'],
        redirectTo: AUTH_REDIRECT_ROUTE,
      },
    },
  },
];
